export const NB: Record<string, string> = {
  "Recommended for you": "Anbefalt for deg",
  "Resource added to favorite": "Ressurs lagt til favoritter",
  "Failed to add resource to favorite": "Kunne ikke legge til ressurs i favoritter",
  "Resource removed from favorite": "Ressurs fjernet fra favoritter",
  "Failed to remove resource from favorite": "Kunne ikke fjerne ressurs fra favoritter",
  "Calendar": "Kalender",
  "View Detail": "Vis detaljer",
  "Add to favorites": "Legg til i favoritter",
  "Remove from favorites": "Fjern fra favoritter",
  "Description: VIP meeting room with a great view and comfortable chairs.": "Beskrivelse: VIP-møterom med flott utsikt og komfortable stoler.",
  
  // NoResultFound
  // case default resource type
  "There are no available resources at the chosen time at your location or in your favorites.": "Det er ingen tilgjengelige ressurser til det valgte tidspunktet på din lokasjon eller i favorittene dine.",
  "You have these options:": "Du har disse alternativene:",
  "Change the meeting time.": "Endre møtetidspunktet.",
  "Use the <1>Find Available Time</1> button to choose a new time.": "Bruk <1>Finn ledig tid</1>-knappen for å velge et nytt tidspunkt.",
  "Open the search to find other resources.": "Åpne søket for å finne andre ressurser.",
  // case not default resource type
  "The resource type <1>'{{resourceType}}'</1> does not exist on your default location": "Ressurstypen <1>'{{resourceType}}'</1> finnes ikke på din standardlokasjon",
  "The resource type <1>'{{resourceType}}'</1> can be found on a different location.": "Ressurstypen <1>'{{resourceType}}'</1> kan finnes på en annen lokasjon.",
  "<1>Click here</1> to add the resource type to your default location settings.": "<1>Klikk her</1> for å legge til ressurstypen i dine standardlokasjonsinnstillinger.",
  
  // ResourceCard
  "New Order": "Ny bestilling",
  "When booking a Pooled Resource, only this resource type and only one can be booked.": "Ved booking av en Pooled Resource kan kun denne ressurstypen og kun en ressurse bookes.",
  "You cannot select both a child resource and its virtual resource at the same time.": "Du kan ikke velge både en underressurs og dens virtuelle ressurs samtidig.",
  // Settings
  "Note:": "Merk:",
  "An Assistant Organizer can receive the same emails from Resource Central as the organizer and can handle orders on behalf of the organizer.": "En assisterende organisator kan motta de samme e-postene fra Resource Central som organisatoren og kan håndtere bestillinger på vegne av organisatoren.",
  "Setting updated successfully": "Innstilling oppdatert",
  "Setting updated failed": "Oppdatering av innstilling mislyktes",
  "@Outlook Add-in Version. 2.0.37 (SR2 1.1 - 11/18/2025)": "@Outlook Add-in Version. 2.0.37 (SR2 1.1 - 11/18/2025)",
  
  // ModalResourceDetail
  "1 space": "1 plass",
  "Opening hours:": "Åpningstider:",
  "Buffer time {{minutes}} mins between reservations": "Buffertid {{minutes}} min mellom reservasjoner",
  "Initial payment {{value}} pr.minute": "Første betaling {{value}} pr. minutt",
  
  // FindAvailableTime
  "Total {{total}} Attendees": "Totalt {{total}} deltakere",
  "{{internal}} of {{total}} internal can attend.": "{{internal}} av {{total}} interne kan delta.",
  "{{external}} external is unknown.": "{{external}} eksterne er ukjent.",
  "Find available time": "Finn ledig tid",
  "Attendees": "Deltakere",
  
  // HelpSetting
  "Click on Further information to visit our support site": "Klikk på Mer informasjon for å besøke vårt støttested",
  "Further information": "Mer informasjon",
  
  // LocationSetting
  "Location changed": "Lokasjon endret",
  "Location change failed": "Endring av lokasjon mislyktes",
  "Please select at least one location": "Vennligst velg minst én lokasjon",
  "Resource types": "Ressurstyper",
  "Location": "Lokasjon",
  "Where": "Hvor",
  
  // ModalShowAttendees
  "Total": "Totalt",
  "Available": "Tilgjengelig",
  "Busy": "Opptatt",
  "External": "Ekstern",
  "Internal": "Intern",
  
  // ResourceSearch
  "Search by resource name": "Søk etter ressursnavn",
  "Category": "Kategori",
  "Filter by Location": "Filtrer etter lokasjon",
  "Filter by Category": "Filtrer etter kategori",
  "Capacity": "Kapasitet",
  "Filter by Capacity": "Filtrer etter kapasitet",
  "All": "Alle",
  "Filter by availability": "Filtrer etter tilgjengelighet",
  "Sort By": "Sorter etter",
  "Loading...": "Laster...",
  
  // SelectedResources
  "Meeting Type": "Møtetype",
  "Meeting Label": "Møteetikett",
  
  // Alert (accessibility text)
  "Check icon": "Avkrysningsikon",
  "Close": "Lukk",
  
  // AppConstants - searchTab
  "Resource": "Ressurs",
  "Person": "Person",
  
  // AppConstants - listQuestionsStart
  "Where do your meetings usually take place?": "Hvor finner møtene dine vanligvis sted?",
  "To improve our recommendations for you we would like you to enter your normal location": "For å forbedre våre anbefalinger for deg, vil vi gjerne at du oppgir din vanlige lokasjon",
  "What do you use most?": "Hva bruker du mest?",
  "To enable quicker and better search please chose you prefered resource type": "For å muliggjøre raskere og bedre søk, vennligst velg din foretrukne ressurstype",
  
  // AppConstants - titlePages
  "Click on resource to pick": "Klikk på ressurs for å velge",
  "Selected Resources": "Valgte ressurser",
  "Setting": "Innstilling",
  "Search": "Søk",
  "Find Colleague": "Finn kollega",
  "Quick button setting": "Hurtigknapp-innstilling",
  "Favorite": "Favoritt",
  "Most Used": "Mest brukte",
  "Colleagues": "Kolleger",
  "Resources": "Ressurser",
  
  // AppConstants - tooltipText
  "Back": "Tilbake",
  "Floor Plan": "Plantegning",
  "Expand": "Utvid",
  "Selected resources": "Valgte ressurser",
  "View details": "Vis detaljer",
  "Remove from My Favorites": "Fjern fra mine favoritter",
  "Add to My Favorites": "Legg til i mine favoritter",
  "Remove": "Fjern",
  "Favorite - Most Used": "Favoritt - Mest brukte",
  "Conflict": "Konflikt",
  "Approved": "Godkjent",
  "Recommendeded for you": "Anbefalt for deg",
  
  // AppConstants - mailFlowOptions
  "Only primary organizer": "Kun primær organisator",
  "Only assistant organizer": "Kun assisterende organisator",
  "Primary AND assistant organizer": "Primær OG assisterende organisator",
  
  // FindColleague
  "Enter colleague name": "Skriv inn kolleganavn",
  "Recent work items": "Nylige arbeidselementer",
  "No data available": "Ingen data tilgjengelig",
  "Floorplan": "Plantegning",
  "List nearby resources": "Liste over ressurser i nærheten",
  "Find resource nearby": "Finn ressurs i nærheten",
  "No Resources available": "Ingen ressurser tilgjengelig",
  
  // Start page
  "Next": "Neste",
  "Failed to update default locations": "Kunne ikke oppdatere standardlokasjoner",
  "Resource Type": "Ressurstype",
  
  // QuickSetting
  "Quick buttons updated successfully": "Hurtigknapper oppdatert",
  "Quick buttons updated failed": "Oppdatering av hurtigknapper mislyktes",
  "Add more": "Legg til mer",
  "Apply": "Bruk",
  "Delete": "Slett",
  "Name": "Navn",
  "Enter name": "Skriv inn navn",
  "Tooltip": "Verktøytips",
  "Enter tooltip": "Skriv inn verktøytips",
  "Type": "Type",
  "Select type": "Velg type",
  "Locations": "Lokasjoner",
  "Select colleagues": "Velg kolleger",
  "Select resources": "Velg ressurser",
  
  // DefaultResourceSetting
  "Resource type changed": "Ressurstype endret",
  "Resource type change failed": "Endring av ressurstype mislyktes",
  "Default Resource Type": "Standard ressurstype",
  
  // AssistantOrganizerSetting
  "Apply Successfully": "Brukt vellykket",
  "Apply Failed": "Bruk mislyktes",
  "Assistant Organizer": "Assisterende organisator",
  "Enter a part of the name to search for": "Skriv inn en del av navnet for å søke",
  "Mail Flow": "E-postflyt",
  "Select Mail Flow": "Velg e-postflyt",
  
  // TileConfigurationSetting
  "Update settings successfully": "Innstillinger oppdatert",
  "Update settings failed": "Oppdatering av innstillinger mislyktes",
  "Timeline": "Tidslinje",
  
  // SelectCategoryForm
  "And": "Og",
  "Or": "Eller",
  
  // Other
  "Resource Calendar": "Ressurskalender",
  
  // SettingLabels
  "Default Location": "Standardlokasjon",
  "Quick button": "Hurtigknapp",
  "Category icons": "Kategoriikoner",
  "Recommendation screen": "Anbefalingsskjerm",
  "Capacity filter": "Kapasitetsfilter",
  "AI Assistant": "AI-assistent",
  "Tile configuration": "Fliskonfigurasjon",
  "Help": "Hjelp",
  "Default Categories": "Standardkategorier",
  
  // MeetingType
  "Your must select a Meeting label": "Du må velge en møteetikett",
  
  // AlternativeResource
  "Selected Resource: 'AOD_Copanhagen' Conflicting Occurrences": "Valgt ressurs: 'AOD_Copanhagen' Motstridende forekomster",
  "Alternative Resource": "Alternativ ressurs",
  "OK": "OK",
  "Cancel": "Avbryt",
  
  // RemovedResource
  "Your selected resources 'AOD_Copenhagen' was removed": "Din valgte ressurs 'AOD_Copenhagen' ble fjernet",
  "You can't book this resource as your request exceeds the available capacity.": "Du kan ikke booke denne ressursen da forespørselen din overstiger tilgjengelig kapasitet.",
  
  // ChangeTime
  "Time changed successfully": "Tid endret vellykket",
  "Current Time": "Nåværende tid",
  "Suggested Times": "Foreslåtte tider",
  "Change Time": "Endre tid",
  "people are free": "personer er ledige",
};

